<div class="modal-header">
  <h5 class="modal-title"><ng-content select="[modal-title]"></ng-content></h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal(null)"></button>
</div>
<div class="modal-body">
  <ng-content select="[modal-body]"></ng-content>
</div>
<div class="modal-footer">
  <ng-content select="[modal-footer]"></ng-content>
</div>
